import { Injectable } from '@angular/core';
import { DateRangeModel } from '../models/date-range-model';
import { Utils } from '../../core/utils';
import { formatDate } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class DropdownFilterService {
  constructor() { }

  getLast120DayDateRanges(): DateRangeModel[] {
    let today = new Date();

    let dateRanges: DateRangeModel[] = [
      { text: 'All', startDate: null, endDate: null, isCustom: false },
      { text: 'Last 30 Days', startDate: formatDate(Utils.getDateWithOffset(-30), 'yyyy-MM-dd', 'en-US'), endDate: formatDate(today, 'yyyy-MM-dd', 'en-US'), isCustom: false },
      { text: 'Last 60 Days', startDate: formatDate(Utils.getDateWithOffset(-60), 'yyyy-MM-dd', 'en-US'), endDate: formatDate(today, 'yyyy-MM-dd', 'en-US'), isCustom: false },
      { text: 'Last 90 Days', startDate: formatDate(Utils.getDateWithOffset(-90), 'yyyy-MM-dd', 'en-US'), endDate: formatDate(today, 'yyyy-MM-dd', 'en-US'), isCustom: false },
      { text: 'Last 120 Days', startDate: formatDate(Utils.getDateWithOffset(-120), 'yyyy-MM-dd', 'en-US'), endDate: formatDate(today, 'yyyy-MM-dd', 'en-US'), isCustom: false },
      { text: 'Custom', startDate: null, endDate: null, isCustom: true },

    ];
    return dateRanges;
  }

}
